import { ValueFormatterParams } from 'ag-grid-community';
import { FC } from 'react';
import {
  Buttons,
  Page,
  TableWrapper,
} from '../../../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Export from '../../../../components/Export/Export';
import Table from '../../../../components/Table/Table';
import { ConfirmationProps } from './Confirmation.types';

const Confirmation: FC<ConfirmationProps> = ({ data }) => {
  const columnDefs = [
    { flex: 1, field: 'newSpecNo', headerName: 'New Spec' },
    { flex: 1, field: 'oldSpecNo', headerName: 'Original Spec' },
    { flex: 1, field: 'description', headerName: 'Description' },
    { flex: 1, field: 'longDescription', headerName: 'Long Description' },
    { flex: 1, field: 'fmsProdNo', headerName: 'FMS ProdNo' },
    {
      flex: 1,
      field: 'createdDate',
      headerName: 'Date/Time',
      resizable: false,
      valueFormatter: (params: ValueFormatterParams) =>
        params.value
          ? `${new Date(params.value).toLocaleDateString()} ${new Date(params.value).toLocaleTimeString()}`
          : '',
    },
  ];

  return (
    <Page data-testid='Confirmation'>
      <TableWrapper>
        <Table floatingFiltersHeight={0} returnedRecords={data?.length} columnDefs={columnDefs} rowData={data || []} />
      </TableWrapper>
      <Buttons>
        <Export
          columnHeaders={columnDefs.map((col) => {
            return { field: col.field, headerName: col.headerName };
          })}
          rowData={data || []}
        />
      </Buttons>
    </Page>
  );
};

export default Confirmation;
